// src/hooks/useUrlChange.js
import { useEffect } from 'react';

function useUrlChange(callback) {
  useEffect(() => {
    const handleLocationChange = () => {
      callback(window.location.pathname);
    };

    handleLocationChange();

    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    window.history.pushState = function (...args) {
      originalPushState.apply(this, args);
      window.dispatchEvent(new Event('locationchange'));
    };

    window.history.replaceState = function (...args) {
      originalReplaceState.apply(this, args);
      window.dispatchEvent(new Event('locationchange'));
    };

    window.addEventListener('popstate', handleLocationChange);
    window.addEventListener('locationchange', handleLocationChange);

    return () => {
      window.removeEventListener('popstate', handleLocationChange);
      window.removeEventListener('locationchange', handleLocationChange);

      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, [callback]);
}

export default useUrlChange;
